import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class QuoteStatusBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            status: this.props.status || '',
            style: this.props.style || {},
            internal: this.props.internal === true,
        }
        this.className = this.props.className || ''
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            status: nextProps.status || '',
            style: nextProps.style || {},
            internal: nextProps.internal === true,
        })
    }

    renderStatus() {
        switch (this.state.status) {
            case 'new':
                return <div className="badge badge-primary text-with-icon">
                    <FormattedMessage
                        id="quote.status.new_label"
                        defaultMessage="New"
                    />
                </div>
            case 'draft':
                return <div className="badge badge-primary text-with-icon">
                    <FormattedMessage
                        id="quote.status.draft_label"
                        defaultMessage="Draft"
                    />
                </div>
            case 'cancelled':
                return <div className="badge badge-light text-with-icon">
                    <FormattedMessage
                        id="quote.status.cancelled_label"
                        defaultMessage="Cancelled"
                    />
                </div>
            case 'proposed':
                return <div className="badge badge-info text-with-icon">
                    <FormattedMessage
                        id="quote.status.proposed_label"
                        defaultMessage="Proposed"
                    />
                </div>
            case 'pre-approved':
                return <div className="badge badge-warning text-with-icon">
                    <FormattedMessage
                        id="quote.status.pre_approved_label"
                        defaultMessage="Pre-approved"
                    />
                </div>
            case 'pre-declined':
                return <div className="badge badge-warning text-with-icon">
                    <FormattedMessage
                        id="quote.status.pre_declined_label"
                        defaultMessage="Declined"
                    />
                </div>
            case 'approved':
                return <div className="badge badge-success text-with-icon">
                    {this.state.internal ? <FormattedMessage
                        id="quote.status.won_label"
                        defaultMessage="Won"
                    /> : <FormattedMessage
                        id="quote.status.approved_label"
                        defaultMessage="Approved"
                    />}
                </div>
            case 'declined':
                return <div className="badge badge-danger text-with-icon">
                    {this.state.internal ? <FormattedMessage
                        id="quote.status.lost_label"
                        defaultMessage="Lost"
                    />: <FormattedMessage
                        id="quote.status.declined_label"
                        defaultMessage="Declined"
                    />}
                </div>
            case 'work-in-progress':
                return <div className="badge badge-warning text-with-icon">
                    <FormattedMessage
                        id="quote.status.work_completed_label"
                        defaultMessage="Work in progress"
                    />
                </div>
            case 'work-completed':
                return <div className="badge badge-success text-with-icon">
                    <FormattedMessage
                        id="quote.status.work_in_progress_label"
                        defaultMessage="Work completed"
                    />
                </div>
            case 'invoiced':
                return <div className="badge badge-custom-secondary text-with-icon">
                    <FormattedMessage
                        id="quote.status.invoiced_label"
                        defaultMessage="Invoiced"
                    />
                </div>
            case 'ordered':
                return <div className="badge badge-custom-secondary text-with-icon">
                    <FormattedMessage
                        id="quote.status.ordered_label"
                        defaultMessage="Ordered"
                    />
                </div>
        }
        return <div></div>
    }

    render() {
        return <span className={this.className} style={this.state.style}>
            {this.renderStatus()}
        </span>
    }

}

export default QuoteStatusBadge





// WEBPACK FOOTER //
// ./src/quote/status.component.jsx